import { render, staticRenderFns } from "./SellInBlock.vue?vue&type=template&id=04649eb9&"
import script from "./SellInBlock.vue?vue&type=script&lang=js&"
export * from "./SellInBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports